var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28033 6.21967C6.98744 5.92678 6.51256 5.92678 6.21967 6.21967C5.92678 6.51256 5.92678 6.98744 6.21967 7.28033L10.9398 12.0004L6.22003 16.7202C5.92714 17.013 5.92714 17.4879 6.22003 17.7808C6.51292 18.0737 6.9878 18.0737 7.28069 17.7808L12.0004 13.0611L16.7198 17.7805C17.0127 18.0734 17.4876 18.0734 17.7805 17.7805C18.0734 17.4876 18.0734 17.0127 17.7805 16.7198L13.0611 12.0004L17.7808 7.28069C18.0737 6.98779 18.0737 6.51292 17.7808 6.22003C17.4879 5.92713 17.0131 5.92713 16.7202 6.22003L12.0004 10.9398L7.28033 6.21967Z",
    fill: "#D9D9D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/CloseGray.3f27b28c5e3ad6cd81334d8fcee843f4.svg";
export { ForwardRef as ReactComponent };